<template>
    <div class="pa-2">
        <template>
            <div>
                <v-row dense class="d-print-none text-right">
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                        <v-btn
                            @click.prevent="backFilter()" 
                            :class="$css_button"
                            outlined
                            :block="$vuetify.breakpoint.smAndDown"
                        >
                            <v-icon left>
                                mdi-magnify
                            </v-icon>
                            pesquisa imóvel
                        </v-btn>
                    </v-col>
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                        <v-btn  
                            @click.prevent="alertPendente()"
                            :class="$css_button"
                            outlined
                            :block="$vuetify.breakpoint.smAndDown"
                        >
                            <v-icon left>mdi-pencil</v-icon> Editar Imovel
                        </v-btn>
                    </v-col>
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                        <v-btn
                            dark
                            color="pink"
                            :class="$css_button"
                            block
                            :to="{ 
                                name: 'admin.properties2.store', 
                            }"
                            v-if="can('Cadastra imóvel')"
                        >
                            Cadastrar um novo imóvel
                        </v-btn>
                    </v-col>
                </v-row>  
            </div>
        </template>  


        <property-show class="mt-4" v-if="item.id" :object="item" />

        <v-dialog
            v-model="dialog"
            persistent
            max-width="500"
        >
            <v-card>
                <v-card-title :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-1 font-weight-medium d-print-none' : 'text-h5 d-print-none'">
                    O status será alterado para Pendente.
                </v-card-title>
                    <v-card-text>Após concluir a edição não esqueça de alterar o status caso necessário. Caso não tenha acesso de alteração de status solicite junto a sua gerência.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="alertPendente()"
                    >
                        Fechar
                    </v-btn>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="setPendente(item.id)"
                    >
                        Prosseguir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import PropertyShow from './PropertyShow.vue';

export default {
    name: 'PropertyIndexShow',

    components: {
       PropertyShow
    },

    mounted() {
        window.scrollTo(0, 0);
    },       

    data() {
        return {
            dialog: false,
            
            item: {
                id: null,
                colaborators: null
            },   // ← variável local para armazenar o resultado            
        };
    },

    computed: {
        ...mapGetters('permissions', ['can']),
    },

    watch: {
        // Recarrega se o UUID mudar (navegação interna)
        '$route.params.uuid': {
            async handler(newUuid) {
                if (newUuid) {
                    try {
                        const result = await this.loadProperty(newUuid);
                        this.item = result.data;
                    } catch (error) {
                        this.item = null;
                        console.error('Erro:', error);
                    } 
                }
            },
            immediate: true
        }
    },

    methods: {
        alertPendente(){
            this.dialog = !this.dialog;
        }, 

        setPendente(id){
            const params = {};
            params.id = id;
            params.status = 'Pendente';
            this.$store.dispatch('updatePropertyStatus', params)
                        .then(response => {
                            this.editItem(id);
                        })
                        .catch(error => {
                            console.log(error)
                            this.$snotify.error('Erro no cadastro')
                        })
        },
        
        editItem(id){
            this.$router.push({
                name: 'admin.properties2.edit',
                params: { uuid: id }
            });
        },

        backFilter(){
            this.$router.push({
                name: 'admin.properties2.filter',
                query: null
            });
            
        },

        ...mapActions(['loadProperty']),  
    }    
    
};

</script>